var map = {
	"./avatar.png": 612,
	"./avatar1.png": 706,
	"./bg-404.png": 3524,
	"./bg_banner_register.jpg": 4557,
	"./bg_card_register.jpg": 3063,
	"./bg_sidenav.png": 8494,
	"./default_foto_gp.png": 7406,
	"./google-meet.png": 4202,
	"./logo-diknas.png": 9378,
	"./logo-kemdikbud.png": 1939,
	"./timezone.jpg": 5867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;